import { Box, Typography, styled } from '@mui/material';
import { CheckIcon } from '../theme/icons';
import { CtrlButton } from '../components/controls/CtrlButton';
import { useRecaptcha } from '../recaptcha/RecaptchaProvider';
import { referralModel } from './ReferralModel';
import { TPortalCustomization } from './sections/utils';

const helpMailsMap = new Map<TPortalCustomization, string>([
    ['Default', 'EZRSupport@onecallcm.com'],
    ['GM', 'GM_Diagnostic@onecallcm.com'],
    ['Navigere', 'EZRSupport@navigere.com'],
]);

const returnToMap = new Map<TPortalCustomization, { label: string, href: string }>([
    ['Default', { label: 'onecallcm.com', href: 'https://www.onecallcm.com' }],
    ['Navigere', { label: 'navigere.com', href: 'https://navigere.com' }],
]);

function HeaderComponent(props: any) {
    const recaptcha = useRecaptcha();

    const { customization } = referralModel.state.use();

    const supportEmail = helpMailsMap.get(customization) || helpMailsMap.get("Default");
    const returnTo = returnToMap.get(customization) || returnToMap.get("Default");

    return (
        <div className={props.className}>
            <Box className="box">
                <img src="/OnecallLogoWithText.png" alt="logo" className="logo" />
                {
                    customization === 'GM'
                    ? <img className='gm-logo' src="/gm-logo.png" alt="gm-logo" />
                    : customization === 'Navigere'
                        ? <img className='navigere-logo' src="/navigere-logo.png" alt="navigere-logo" />
                        : null
                }
                <div className="actions">
                    <div className='actions-links'>
                        <a href={returnTo?.href} rel="noopener noreferrer">{returnTo?.label}</a>
                        <Typography variant="body1" className="help">
                            For help: {<a href={`mailto:${supportEmail}`}>{supportEmail}</a>}
                        </Typography>
                    </div>
                    <CtrlButton
                        startIcon={<CheckIcon />}
                        variant="contained"
                        onClick={(e) => referralModel.handleSubmit(e, recaptcha!.getToken)}
                    >
                        Submit Referral
                    </CtrlButton>
                </div>
            </Box>
        </div>
    );
}

export const Header = styled(HeaderComponent, { name: 'Header' })(({ theme }) => ({
    position: 'sticky',
    top: 0,
    background: theme.app.neutralColor.white,
    borderBottom: `solid 1px ${theme.app.neutralColor.borderMain}`,
    shadow: theme.app.neutralColor.shadow1,
    zIndex: 2000,
    '.box': {
        alignItems: 'center',
        display: 'flex',
        height: 137,
        padding: theme.spacing(4, 5, 4, 6),
    },
    '.text': {
        marginLeft: theme.spacing(6),
    },
    '.logo': {
        width: 160,
    },
    '.help': {
        color: theme.app.neutralColor.textMain,
        alignSelf: 'center',
    },
    '.actions': {
        display: 'flex',
        columnGap: theme.spacing(7),
        marginLeft: 'auto',
        alignItems: 'center'
    },
    '.actions-links': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    '.gm-logo': {
        width: 32,
        height: 32,
        marginLeft: 32
    },
    '.navigere-logo': {
        width: 105,
        height: 36,
        marginLeft: 32
    }
}));
